var map = {
	"./branding": 59,
	"./branding.js": 59,
	"./enershare/enershare-functions": 242,
	"./enershare/enershare-functions.js": 242,
	"./enershare/enershare-values": 373,
	"./enershare/enershare-values.js": 373,
	"./enershare/img/logo_Enershare.svg": 465,
	"./enershare/img/logo_Enershare_Icon.svg": 1077,
	"./enertef/enertef-functions": 243,
	"./enertef/enertef-functions.js": 243,
	"./enertef/enertef-values": 374,
	"./enertef/enertef-values.js": 374,
	"./enertef/img/logo_EnerTEF.svg": 466,
	"./enertef/img/logo_EnerTEF_Icon.svg": 1078,
	"./opalrt/img/datamodel.png": 1079,
	"./opalrt/img/eonerc_rwth.svg": 618,
	"./opalrt/img/logo_opalrt.svg": 617,
	"./opalrt/img/logo_opalrt_square.svg": 1080,
	"./opalrt/opalrt-functions": 241,
	"./opalrt/opalrt-functions.js": 241,
	"./opalrt/opalrt-values": 372,
	"./opalrt/opalrt-values.js": 372,
	"./slew/img/eonerc_rwth.svg": 614,
	"./slew/img/erigrid2.png": 615,
	"./slew/img/european_commission.svg": 616,
	"./slew/img/slew_blue.svg": 1081,
	"./slew/img/slew_logo.png": 1082,
	"./slew/img/slew_magenta.svg": 1083,
	"./slew/slew-functions": 306,
	"./slew/slew-functions.js": 306,
	"./slew/slew-values": 371,
	"./slew/slew-values.js": 371,
	"./slew/slew.css": 613,
	"./template/img/template_logo.svg": 619,
	"./template/template-functions": 244,
	"./template/template-functions.js": 244,
	"./template/template-values": 375,
	"./template/template-values.js": 375,
	"./villasweb/img/datamodel.png": 1084,
	"./villasweb/img/eonerc_rwth.svg": 608,
	"./villasweb/img/erigrid2.png": 612,
	"./villasweb/img/european_commission.svg": 464,
	"./villasweb/img/jara.svg": 1085,
	"./villasweb/img/reserve.svg": 611,
	"./villasweb/img/uel.png": 610,
	"./villasweb/img/uel_efre.jpeg": 609,
	"./villasweb/img/villas_web.svg": 607,
	"./villasweb/villasweb-functions": 198,
	"./villasweb/villasweb-functions.js": 198,
	"./villasweb/villasweb-values": 305,
	"./villasweb/villasweb-values.js": 305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1076;